import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getNewarkStructuredData() {
  const url = "https://restorehair.com/locations/new-jersey/newark/";
  const description =
    "Find out about your hair transplant options in Newark with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("newark", url, description),
    locationPageCrumbs(url, "Newark"),
  ];
}
